// Utility for managing CSRF tokens
let csrfToken = null;

export const getCsrfToken = async () => {
  // Return cached token if available
  if (csrfToken) {
    return csrfToken;
  }

  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/csrf-token`, {
      credentials: 'include'
    });
    const data = await res.json();
    csrfToken = data.csrfToken;
    return csrfToken;
  } catch (err) {
    console.error('Failed to fetch CSRF token:', err);
    throw new Error('Unable to get CSRF token');
  }
};

export const clearCsrfToken = () => {
  csrfToken = null;
};

// Fetch wrapper that automatically includes CSRF token for POST/PUT/DELETE requests
export const apiFetch = async (url, options = {}) => {
  const method = options.method || 'GET';

  // Add JWT token from localStorage
  const token = localStorage.getItem('token');
  if (token) {
    options.headers = {
      ...options.headers,
      'Authorization': `Bearer ${token}`
    };
  }

  // Only add CSRF token for non-GET requests
  if (method !== 'GET') {
    const csrfToken = await getCsrfToken();
    options.headers = {
      ...options.headers,
      'X-CSRF-Token': csrfToken
    };
  }

  // Always include credentials for cookies
  options.credentials = 'include';

  return fetch(url, options);
};
